import { Heading } from 'ui/components/primitives';
import { styled } from 'ui/theme';

export const Payment = {
  Heading: styled(Heading)`
    font-weight: normal;
  `,
};
